// const isLocalNetwork = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
// const backendDomain = process.env.NODE_ENV === 'development'
//     ? (isLocalNetwork ? `http://${window.location.hostname}:5000` : "http://localhost:5000")
//     : process.env.NODE_ENV === 'production'
//         // ? "https://naach-boutique.onrender.com"   // Use the production API in production environment
//         ? "https://rtex-development.onrender.com"
//         : "http://192.168.0.15:5000";     // Fallback URL (for local network testing)
const isLocalNetwork = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';

const backendDomain = process.env.NODE_ENV === 'development'
    ? (isLocalNetwork ? `http://${window.location.hostname}:5000` : "http://localhost:5000")
    : process.env.NODE_ENV === 'production'
        // ? "https://naach-boutique.onrender.com"   // Use the production API in production environment
        ? "https://r-tex-e-com.onrender.com"
        : "http://192.168.0.15:5000";

//cSpell: ignore deactive

const SummaryApi = {
    // ===================== AUTH ROUTES=====================
    register: {
        url: `${backendDomain}/api/auth/register`,
        method: "post"
    },
    verifyOtp: {
        url: `${backendDomain}/api/auth/verify-otp`,
        method: "post"
    },
    signIn: {
        url: `${backendDomain}/api/auth/login`,
        method: "post"
    },
    forgotPassword: {
        url: `${backendDomain}/api/user/forgot-password`,
        method: "post"
    },
    resetPassword: {
        url: `${backendDomain}/api/user/reset-password`,
        method: "post"
    },
    googleLogin: {
        url: `${backendDomain}/api/auth/google-login`,
        method: "post",
    },
    facebookLogin: {
        url: `${backendDomain}/api/auth/facebook-login`,
        method: "post",
    },


    // ===================== USERS / CUSTOMERS ROUTES =====================
    getProfile: {
        url: `${backendDomain}/api/user/profile`,
        method: "get"
    },
    updateProfile: {
        url: `${backendDomain}/api/user/update-profile`,
        method: "put"
    },
    getAllUsers: {
        url: `${backendDomain}/api/user/customers`,
        method: "get"
    },
    updateUserRole: {
        url: (userId) => `${backendDomain}/api/user/update-role/${userId}`,
        method: "put"
    },

    // ===================== ADMIN PRODUCTS ROUTES =====================
    uploadVariantImages: {
        url: (variantId) => `${backendDomain}/api/products/variant/${variantId}/images`,
        method: "post"
    },
    getAllProducts: {
        url: `${backendDomain}/api/products/view-all`,
        method: "get"
    },
    getOneProduct: {
        url: (productId) => `${backendDomain}/api/products/view/${productId}`,
        method: "get"
    },
    createProduct: {
        url: `${backendDomain}/api/products/upload`,
        method: "post"
    },
    updateProduct: {
        url: (productId) => `${backendDomain}/api/products/product/${productId}`,
        method: "put"
    },
    deleteProduct: {
        url: (productId) => `${backendDomain}/api/products/product/${productId}`,
        method: "delete"
    },
    getSimilarProducts: {
        url: (productId) => `${backendDomain}/api/products/similar/${productId}`,
        method: "GET",
    },


    // Category endpoints
    createTopCategory: {
        url: `${backendDomain}/api/top-category/add-top-category`,
        method: "post"
    },
    getAllTopCategories: {
        url: `${backendDomain}/api/top-category/view-all`,
        method: "get"
    },
    updateTopCategory: {
        url: (id) => `${backendDomain}/api/top-category/update-top-category/${id}`,
        method: "put"
    },
    deleteTopCategory: {
        url: (id) => `${backendDomain}/api/top-category/delete-top-category/${id}`,
        method: "delete"
    },
    hideTopCategory: {
        url: (id) => `${backendDomain}/api/top-category/hide-top-category/${id}`,
        method: "patch"
    },

    // Sub Category endpoints
    createSubCategory: {
        url: `${backendDomain}/api/sub-category/add-sub-category`,
        method: "post"
    },
    getAllSubCategories: {
        url: `${backendDomain}/api/sub-category/view-all`,
        method: "get"
    },
    updateSubCategory: {
        url: (id) => `${backendDomain}/api/sub-category/update-sub-category/${id}`,
        method: "put"
    },
    deleteSubCategory: {
        url: (id) => `${backendDomain}/api/sub-category/delete-sub-category/${id}`,
        method: "delete"
    },
    hideSubCategory: {
        url: (id) => `${backendDomain}/api/sub-category/hide-sub-category/${id}`,
        method: "put"
    },

    // Banner APIs
    createBanner: {
        url: `${backendDomain}/api/banner/add`,
        method: "post"
    },

    getBannersByCategory: {
        url: (slug) => `${backendDomain}/api/banner/category/${slug}`,
        method: "get"
    },
    getAllBanners: {
        url: `${backendDomain}/api/banner/view-all`,
        method: "get"
    },

    deleteBanner: {
        url: (id) => `${backendDomain}/api/banner/delete/${id}`,
        method: "delete"
    },

    toggleWishlist: {
        url: `${backendDomain}/api/wishlist/toggle`,
        method: "post",
    },
    getWishlist: {
        url: `${backendDomain}/api/wishlist/view`,
        method: "get",
    },

    // ===================== ADDRESS ROUTES =====================
    addAddress: {
        url: `${backendDomain}/api/address/add`,
        method: "post"
    },
    getMyAddresses: {
        url: `${backendDomain}/api/address/view-all`,
        method: "get"
    },
    getAddressById: {
        url: (id) => `${backendDomain}/api/address/view/${id}`,
        method: "get"
    },
    updateAddress: {
        url: (id) => `${backendDomain}/api/address/update/${id}`,
        method: "put"
    },
    deleteAddress: {
        url: (id) => `${backendDomain}/api/address/delete/${id}`,
        method: "delete",
    },
    addAddressByLocation: {
        url: `${backendDomain}/api/address/add-by-location`,
        method: "post",
    },
    setDefaultAddress: {
        url: (id) => `${backendDomain}/api/address/set-default/${id}`,
        method: "patch",
    },

    // ===================== REVIEWS ROUTES =====================
    addOrUpdateReview: {
        url: `${backendDomain}/api/review/add`,
        method: "post",
    },

    getProductReviews: {
        url: (productId) => `${backendDomain}/api/review/view/${productId}`,
        method: "get",
    },

    deleteReview: {
        url: (reviewId) => `${backendDomain}/api/review/delete/${reviewId}`,
        method: "delete",
    },

    getMyReview: {
        url: (productId) => `${backendDomain}/api/review/my/${productId}`,
        method: "get",
    },


    // ===================== PRODUCTS ROUTES =====================
    getAllUserProducts: {
        url: `${backendDomain}/api/products/view-all`,
        method: "get"
    },

    getCategoryProducts: {
        url: (categorySlug) => `${backendDomain}/api/products/by-top-category/${categorySlug}`,
        method: "get",
    },
    categoryWiseProduct: {
        url: (topCategory, subCategory) => `${backendDomain}/api/products/products?topCategory=${topCategory}&subCategory=${subCategory}`,
        method: "get",
    },
    
    // ===================== COUPONS ROUTES =====================
    createCoupon: {
        url: `${backendDomain}/api/coupon/create`,
        method: 'post'
    },
    allCoupons: {
        url: `${backendDomain}/api/coupon/view-all`,
        method: 'get'
    },
    updateCoupon: {
        url: (id) => `${backendDomain}/api/coupon/update/${id}`,
        method: 'put'
    },
    deleteCoupon: {
        url: (id) => `${backendDomain}/api/coupon/delete/${id}`,
        method: 'delete'
    },
    toggleCoupon: {
        url: (id) => `${backendDomain}/api/coupon/toggle/${id}`,
        method: 'put'
    },
    getApplicableCoupons: {
        url: `${backendDomain}/api/coupon/applicable`,
        method: 'post'
    },
    verifyCoupon: {
        url: `${backendDomain}/api/coupon/verify`,
        method: 'post'
    },

    // ===================== CART ROUTES =====================
    addToCart: {
        url: `${backendDomain}/api/cart/add`,
        method: "post"
    },
    getCartItems: {
        url: `${backendDomain}/api/cart/view`,
        method: "get"
    },
    updateCartItem: {
        url: (id) => `${backendDomain}/api/cart/update/${id}`,
        method: "put"
    },
    removeCartItem: {
        url: (id) => `${backendDomain}/api/cart/remove/${id}`,
        method: "delete"
    },
    getGuestCart: {
        url: `${backendDomain}/api/cart/guest`,
        method: "post"
    },
    fetchTopSelling: {
        url: (categorySlug) => `${backendDomain}/api/products/trending/${categorySlug}`,
        method: "get"
    },
    fetchNewArrivals: {
        url: (categorySlug) => `${backendDomain}/api/products/new-arrivals/${categorySlug}`,
        method: "get"
    },
    fetchOfferProducts: {
        url: (categorySlug) => `${backendDomain}/api/products/offers/${categorySlug}`,
        method: "get"
    },
    getCategoryTree: {
        url: `${backendDomain}/api/category-tree/view-all`,
        method: "get"
    },
    submitContact: {
        url: `${backendDomain}/api/contact/submit`,
        method: "post",
    },

    // ===================== ORDERS ROUTES =====================
    createOrder: {
        url: `${backendDomain}/api/order/create-order`,
        method: "post"
    },
    verifyPayment: {
        url: `${backendDomain}/api/order/ver-pay`,
        method: 'post'
    },

    getAllOrders: { // For Admin
        url: `${backendDomain}/api/order/view-all`,
        method: "get",
    },
    getMyOrders: {
        // url: `${backendDomain}/api/orders/my-orders`,
        url: `${backendDomain}/api/order/view-all-user-orders`,
        method: "get",
    },
    getOrderById: {
        url: (id) => `${backendDomain}/api/order/view-one/${id}`,
        method: "get",
    },
    updateOrderStatus: {
        url: (orderId) => `${backendDomain}/api/order/update/${orderId}/status`,
        method: "patch"
    },
      cancelOrder: {
        url: `${backendDomain}/api/order/cancel-order`,
        method: "POST",
    },
    requestReturnOrder: {
        url: `${backendDomain}/api/order/request-return`,
        method: "POST",
    },
    adminReturnAction: {
        url: (id) => `${backendDomain}/api/order/admin-return-action/${id}`,
        method: "POST",
    },
    getReturnedOrders: {
        url: `${backendDomain}/api/order/get-returned-orders`,
        method: "GET",
    },
    // ===================== DASHBOARD ROUTES =====================

    dashboardStats: { // For Admin
        url: `${backendDomain}/api/dashboard/stats`,
        method: "get",
    },
    dashboardRevenue: {
        url: `${backendDomain}/api/dashboard/revenue`,
        method: "get"
    },
    getBestSellers: {
        url: `${backendDomain}/api/dashboard/best-sellers`,
        method: "get",
    },
    getRevenueComparison: {
        url: `${backendDomain}/api/dashboard/revenue-comparison`,
        method: "get",
    },
    getTopCategoriesRevenue: {
        url: `${backendDomain}/api/dashboard/top-categories`,
        method: "get",
    },
    getKidsAgeGroups: {
        url: `${backendDomain}/api/products/kids/age-groups`,
        method: "get",
    },

    // ===================== SEARCH ROUTES =====================
    searchText: {
        url: `${backendDomain}/api/search/text`,
        method: "get"
    },
    searchImage: {
        url: `${backendDomain}/api/search/image`,
        method: "post"
    },
    searchSuggestions: {
        url: `${backendDomain}/api/search/suggestions`,
        method: "get"
    },


};

export default SummaryApi;




// const isLocalNetwork = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';

// const backendDomain = process.env.NODE_ENV === 'development'
//     ? (isLocalNetwork ? `http://${window.location.hostname}:5000` : "http://localhost:5000")
//     : process.env.NODE_ENV === 'production'
//         // ? "https://naach-boutique.onrender.com"   // Use the production API in production environment
//         ? "https://rtex-development.onrender.com"
//         : "http://192.168.0.15:5000";     // Fallback URL (for local network testing)

// //cSpell: ignore deactive

// const SummaryApi = {
//     // User Routes
//     createUser: {
//         url: `${backendDomain}/api/users/add-user`,
//         method: "post"
//     },
//     signIn: {
//         url: `${backendDomain}/api/auth/login`,
//         method: "post"
//     },
//     updateUser: {
//         url: (userId) => `${backendDomain}/api/users/update-user/${userId}`,
//         method: "put"
//     },
//     updateProfile: {
//         url: `${backendDomain}/api/users/update-my-profile`,
//         method: "put"
//     },
//     getAllUsers: {
//         url: `${backendDomain}/api/users/view-all-users`,
//         method: "get"
//     },
//     getUserById: {
//         url: (userId) => `${backendDomain}/api/users/view-one-users/${userId}`,
//         method: "get"
//     },
//     sendResetLink: {
//         url: `${backendDomain}/api/users/send-reset-link`,
//         method: "post"
//     },
//     resetPassword: {
//         url: `${backendDomain}/api/users/reset-password`,
//         method: "post"
//     },

//     // Branch Routes
//     createBranch: {
//         url: `${backendDomain}/api/branches/add-branch`,
//         method: "post"
//     },
//     getBranchById: {
//         url: (branchId) => `${backendDomain}/api/branches/view-branch/${branchId}`,
//         method: "get"
//     },
//     getAllBranches: {
//         url: `${backendDomain}/api/branches/view-all-branches`,
//         method: "get"
//     },
//     filterBranches: {
//         url: `${backendDomain}/api/branches/filter-branches`,
//         method: "get"
//     },
//     updateBranch: {
//         url: (branchId) => `${backendDomain}/api/branches/update-branch/${branchId}`,
//         method: "put"
//     },
//     toggleBranchStatus: {
//         url: (branchId) => `${backendDomain}/api/branches/active-deactive-branch/${branchId}`,
//         method: "put"
//     },
//     deleteBranch: {
//         url: (branchId) => `${backendDomain}/api/branches/delete-branch/${branchId}`,
//         method: "delete"
//     },

//     // Role Routes
//     createRole: {
//         url: `${backendDomain}/api/roles/add-role`,
//         method: "post"
//     },
//     updateRole: {
//         url: (roleId) => `${backendDomain}/api/roles/update-role/${roleId}`,
//         method: "put"
//     },
//     getAllRoles: {
//         url: `${backendDomain}/api/roles/view-all-roles`,
//         method: "get"
//     },
//     getRoleById: {
//         url: (roleId) => `${backendDomain}/api/roles/view-role/${roleId}`,
//         method: "get"
//     },
//     deleteRole: {
//         url: (roleId) => `${backendDomain}/api/roles/delete-role/${roleId}`,
//         method: "delete"
//     },

//     // Category Routes
//     createCategory: {
//         url: `${backendDomain}/api/categories/add-category`,
//         method: "post"
//     },
//     getAllCategories: {
//         url: `${backendDomain}/api/categories/view-all-categories`,
//         method: "get"
//     },
//     getCategoryById: {
//         url: (categoryId) => `${backendDomain}/api/categories/view-category/${categoryId}`,
//         method: "get"
//     },
//     updateCategory: {
//         url: (categoryId) => `${backendDomain}/api/categories/update-category/${categoryId}`,
//         method: "put"
//     },
//     deleteCategory: {
//         url: (categoryId) => `${backendDomain}/api/categories/delete-category/${categoryId}`,
//         method: "delete"
//     },
//     deleteModel: {
//         url: (categoryId, modelId) => `${backendDomain}/api/categories/${categoryId}/delete-model/${modelId}`,
//         method: "delete"
//     },

//     // Neck Design Routes
//     createNeckDesign: {
//         url: `${backendDomain}/api/neck-designs/add-neck-design`,
//         method: "post"
//     },
//     getAllNeckDesigns: {
//         url: `${backendDomain}/api/neck-designs/view-neck-designs`,
//         method: "get"
//     },
//     getNeckDesignById: {
//         url: (neckDesignId) => `${backendDomain}/api/neck-designs/view-neck-design/${neckDesignId}`,
//         method: "get"
//     },
//     updateSingleNeckImage: {
//         url: (designId) => `${backendDomain}/api/neck-designs/update-one-neck-design/${designId}`,
//         method: "put"
//     },
//     updateNeckDesign: {
//         url: (neckDesignId) => `${backendDomain}/api/neck-designs/update-neck-design/${neckDesignId}`,
//         method: "patch"
//     },
//     deleteNeckDesign: {
//         url: (neckDesignId) => `${backendDomain}/api/neck-designs/delete-neck-design/${neckDesignId}`,
//         method: "delete"
//     },

//     // Order Routes
//     createOrder: {
//         url: `${backendDomain}/api/orders/add-order`,
//         method: "post"
//     },
//     getAllOrders: {
//         url: `${backendDomain}/api/orders/view-all-orders`,
//         method: "get"
//     },
//     getOrderById: {
//         url: (orderId) => `${backendDomain}/api/orders/view-order/${orderId}`,
//         method: "get"
//     },
//     updateOrder: {
//         url: (orderId) => `${backendDomain}/api/orders/update-order/${orderId}`,
//         method: "put"
//     },
//     updateOrderStatus: {
//         url: (orderId) => `${backendDomain}/api/orders/update-order-status/${orderId}`,
//         method: "put"
//     },
//     deleteOrder: {
//         url: (orderId) => `${backendDomain}/api/orders/delete-order/${orderId}`,
//         method: "delete"
//     },
//     cancelOrder: {
//         url: (orderId) => `${backendDomain}/api/orders/cancel-order/${orderId}`,
//         method: "put",
//     },

//     calendarView: {
//         url: ({ fromDate = '', toDate = '', month = '', year = '' }) =>
//             `${backendDomain}/api/orders/getOrderView?fromDate=${fromDate}&toDate=${toDate}&month=${month}&year=${year}`,
//         method: 'get'
//     },
//     searchByMobile: {
//         url: `${backendDomain}/api/orders/view-orders-by-mobile`,
//         method: "get"
//     },
//     ordersCardCount: {
//         url: `${backendDomain}/api/orders/cards-count`,
//         method: "get"
//     },
//     allTailorsCuttingMasters: {
//         url: `${backendDomain}/api/orders/get-tailor-cutting-master`,
//         method: "get"
//     },
//     reassignWorker: {
//         url: (orderId) => `${backendDomain}/api/orders/handle-worker-reassignment/${orderId}`,
//         method: "put"
//     },

//     // Reports routes
//     getReportCounts: {
//         url: `${backendDomain}/api/reports/counts`,
//         method: "get"
//     },
//     getOrderReports: {
//         url: `${backendDomain}/api/reports/orders`,
//         method: "get"
//     },
//     getWorkerReports: {
//         url: ({ workerId = '', fromDate = '', toDate = '' }) => `${backendDomain}/api/reports/workers?workerId=${workerId}&fromDate=${fromDate}&toDate=${toDate || fromDate}`,
//         method: "get"
//     },
//     getBranchReports: {
//         url: ({ year = '', month = '', branchCode = '', fromDate = '', toDate = '' }) => `${backendDomain}/api/reports/branches?year=${year}&month=${month}&startDate=${fromDate}&endDate=${toDate || fromDate}&branchCode=${branchCode}`,
//         method: "get"
//     },
//     getPaymentReports: {
//         url: ({ fromDate = '', toDate = '' }) => `${backendDomain}/api/reports/payment?fromDate=${fromDate}&toDate=${toDate || fromDate}`,
//         method: "get"
//     },
//     getPayrollReports: {
//         url: ({ fromDate = '', toDate = '', branch = '', role = '', salaryType = ''}) =>
//             `${backendDomain}/api/reports/payroll?fromDate=${fromDate}&toDate=${toDate || fromDate}&branch=${branch}&role=${role}&salaryType=${salaryType}`,
//         method: "get",
//     },


//     // expense and Income Routes
//     getExpenseDashboard: {
//         url: ({ year = '', month = '', branch = '' }) => `${backendDomain}/api/expenses/dashboard?year=${year}&month=${month}&branch=${branch}`,
//         method: "get"
//     },
//     getAllExpenses: {
//         url: `${backendDomain}/api/expenses/view-all-expenses`,
//         method: "get"
//     },
//     createExpense: {
//         url: `${backendDomain}/api/expenses/add-expense`,
//         method: "post"
//     },
//     updateExpense: {
//         url: (expenseId) => `${backendDomain}/api/expenses/update-expense/${expenseId}`,
//         method: "put"
//     },
//     deleteExpense: {
//         url: (expenseId) => `${backendDomain}/api/expenses/delete-expense/${expenseId}`,
//         method: "delete"
//     },

//     //Wallet Routes
//     getWalletOverview: {
//         url: `${backendDomain}/api/wallet/summary`,
//         method: "get"
//     },
//     getAllWalletLists: {
//         url: ({ fromDate = '', toDate = '' }) => `${backendDomain}/api/wallet/list?fromDate=${fromDate}&toDate=${toDate || fromDate}`,
//         method: "get"
//     },
//     viewOneInvoice: {
//         url: (invoiceId) => `${backendDomain}/api/invoice/${invoiceId}`,
//         method: "get"
//     },
//     // updateWalletTransaction: {
//     //     url: (transactionId) => `${backendDomain}/api/wallet/update-transaction/${transactionId}`,
//     //     method: "put"
//     // },
//     // deleteWalletTransaction: {
//     //     url: (transactionId) => `${backendDomain}/api/wallet/delete-transaction/${transactionId}`,
//     //     method: "delete"
//     // }

//     // Delivery Routes
//     getAllDeliveries: {
//         url: `${backendDomain}/api/delivery/delivered-orders`,
//         method: "get"
//     },
//     deliveryCounts: {
//         url: ({ year = '', month = '', branch = '' }) => `${backendDomain}/api/delivery/counts?year=${year}&month=${month}&branch=${branch}`,
//         method: "get"
//     },
//     deliveryTrends: {
//         url: ({ year = '', branch = '' }) => `${backendDomain}/api/delivery/trends?year=${year}&branch=${branch}`,
//         method: "get"
//     },
//     deliveryStatus: {
//         url: `${backendDomain}/api/delivery/status`,
//         method: "get"
//     },

//     //Dashboard Routes
//     dashboardWeekFilter: {
//         url: `${backendDomain}/api/dashboard/available-weeks`,
//         method: "get"
//     },
//     dashboardCardStats: {
//         url: ({ month = '', year = '', branch = '', fromDate = '', toDate = '' }) => `${backendDomain}/api/dashboard/card-stats?month=${month}&year=${year}&branch=${branch}&fromDate=${fromDate}&toDate=${toDate}`,
//         method: "get"
//     },
//     dashboardOrderTrends: {
//         url: ({ weekDate = '', branch = '' }) => `${backendDomain}/api/dashboard/weekly-order-trend?weekDate=${weekDate}&branch=${branch}`,
//         method: "get"
//     },
//     dashboardBranchCharts: {
//         url: ({ weekDate = '' }) => `${backendDomain}/api/dashboard/top-branches?weekDate=${weekDate}`,
//         method: "get"
//     },
//     dashboardTopWorkers: {
//         url: ({ month = '', year = '' }) => `${backendDomain}/api/dashboard/top-workers?month=${month}&year=${year}`,
//         method: "get"
//     },
//     dashboardTodayOrders: {
//         url: `${backendDomain}/api/dashboard/today-orders`,
//         method: "get"
//     },
//     dashboardDelayedDeliveries: {
//         url: `${backendDomain}/api/dashboard/delayed-deliveries`,
//         method: "get"
//     },
//     dashboardTodayDeliveries: {
//         url: `${backendDomain}/api/dashboard/today-deliveries`,
//         method: "get"
//     },

//     // Salary Routes
//     salarySummary: {
//         url: ({ year = '', month = '', branch = '' }) =>
//             `${backendDomain}/api/salary/payroll-summary?year=${year}&month=${month}&branch=${branch}`,
//         method: "get",
//     },
//     SalaryOutstanding: {
//         url: ({ year = '', branch = '' }) =>
//             `${backendDomain}/api/salary/outstanding-trends?year=${year}&branch=${branch}`,
//         method: "get",
//     },
//     SalaryStatus: {
//         url: `${backendDomain}/api/salary/salary-breakdown`,
//         method: "get",
//     },
//     getAllSalaries: {
//         url: `${backendDomain}/api/salary/view-all`,
//         method: "get",
//     },

//     generateSalaries: {
//         url: ({ query }) => `${backendDomain}/api/salary/generate?${query}`,
//         method: "get"
//     },

//     updateSalary: {
//         url: (id) => `${backendDomain}/api/salary/update/${id}`,
//         method: "patch"
//     },

//     deleteSalary: {
//         url: (salaryId) => `${backendDomain}/api/salary/delete/${salaryId}`,
//         method: "delete"
//     },



//     dashboardTopPerformBranch: {
//         url: ({ month = '', year = '' }) => `${backendDomain}/api/dashboard/top-performers?month=${month}&year=${year}`,
//         method: "get"
//     },

//     //Measurements
//     getMeasurements: {
//         url: `${backendDomain}/api/measurements/all-measurements`,
//         method: "get"
//     },
//     getMeasurementByOrderId: {
//         url: (orderId) => `${backendDomain}/api/measurements/${orderId}`,
//         method: "get"
//     }

// };

// export default SummaryApi;


